module.exports = __webpack_public_path__ + "img/auto.c145e7d0.png";